import CTACardsContainer from "../../../../Component/Application/CTAs/CTACards/CTACards";

const CTACards = () => {
  return (
    <div className="page-body">
      <CTACardsContainer />
    </div>
  );
};

export default CTACards;
